<div class="container-fluid p-2 m-0">
 
    <div class="row w-100 m-0 p-1 bg-white shadow">
        <div class=" title-header w-100"><h5 class="m-0 p-0">Change Password</h5>
        </div>

        <div class="col-lg-12 m-0 p-5 grid-margin stretch-card">
                <form [formGroup]="passwordForm"  (ngSubmit)="onPasswordChange()">
                  <fieldset>
                    <div class="row mp-0 w-100">
                        <div class="col-lg-8 mp-0">
                            <div class="form-row m-0 p-0" >
                                <div class="col-md-6 p-2">
                                    <div class="form-group">
                                        <label>Old Password</label>
                                        <input type="password" formControlName="o_password" class="form-control" [ngClass]="{ 'is-invalid': submitted && formU.o_password.errors }" />
                                        <div *ngIf="submitted && formU.o_password.errors" class="invalid-feedback">
                                            <div *ngIf="formU.o_password.errors.required">Old Password is required</div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-8 mp-0">
                            <div class="form-row m-0 p-0" >
                            <div class="col-md-6 p-2">
                                <div class="form-group">
                                    <label>Password</label>
                                    <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && formU.password.errors }" />
                                    <div *ngIf="submitted && formU.password.errors" class="invalid-feedback">
                                        <div *ngIf="formU.password.errors.required">Password is required</div>
                                        <div *ngIf="formU.password.errors.minlength">Password must be at least 6 characters</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 p-2">
                                <div class="form-group">
                                <label>Confirm Password</label>
                                <input type="password" formControlName="confirmPassword" class="form-control" [ngClass]="{ 'is-invalid': submitted && formU.confirmPassword.errors }" />
                                <div *ngIf="submitted && formU.confirmPassword.errors" class="invalid-feedback">
                                    <div *ngIf="formU.confirmPassword.errors.required">Confirm Password is required</div>
                                    <div *ngIf="formU.confirmPassword.errors.confirmedValidator">New Password and Confirm Password are not matching</div>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div>

                        <div class="col-lg-8 mp-0">
                            <div class="text-center mt-3">
                                <button  class="btn btn-success mt-2 mr-3 btn-w">Change Password</button>
                             </div>
                        </div>

                    </div>
                   </fieldset>
                </form>
            </div>
          </div>

        
</div>